'use client'

import { useStore } from '@shared/lib/store'
import { writable } from '@shared/lib/store'
import Search from '@shared/components/Search/Search'
import Input from '@shared/components/Input/Input'
import { Suspense } from 'react'
import { desktop } from '@/styles/theme.css'
import { isDev } from '@shared/lib/utils'

export const isGhostStore = writable(false)

const style = { width: '17em' }
const inputProps = { style: { paddingRight: 95 } }
export function NavBarSearch() {
  const ghost = useStore(isGhostStore)

  return (
    <Suspense fallback={<Input className={desktop} style={style} />}>
      <Search
        slackMsgEnvironmentPrefix={isDev ? '[DEV]' : '[PROD]'}
        enableShortcut={!ghost}
        id='navbar-search'
        style={style}
        inputProps={inputProps}
        className={desktop}
      />
    </Suspense>
  )
}
